<script setup lang="ts">
import { computed, toRef } from 'vue';

import VButton from '@components/buttons/VButton/VButton.vue';
import { useDevice } from '@modules/core/composables/device';
import { MERCHANT_SETTINGS_PERMISSIONS } from '@modules/merchant-settings/constants';
import { ADMIN_MERCHANT_SETTINGS_EDIT_ROUTE_NAME } from '@modules/merchant-settings/submodules/edit/constants';
import { useMerchantStore } from '@modules/merchant/store';

const merchant = toRef(useMerchantStore(), 'merchant');
const { isDesktop } = useDevice();

const noLogoLabel = 'No Merchant Logo';

// TODO: Backend set default image but it might not work. Probably, there is no need. Should check it.
const isLogo = computed(() => merchant.value?.logo_url && !merchant.value.logo_url.includes('missing.png'));
</script>

<template>
  <div v-data-qa-auto-id="'TheMerchantLogo'"
    class="p-2"
    :class="{ 'bg-surface-50': isDesktop, 'bg-content-color': !isDesktop }"
  >
    <div
      class="flex h-24 w-full items-center justify-center overflow-hidden"
      :class="{ 'bg-primary-50': !isLogo }"
    >
      <img
        v-if="isLogo"
        :src="merchant?.logo_url"
        class="max-h-full max-w-full"
        :alt="`${merchant?.merchant_name} logo`"
      >
      <div v-else>
        <VButton
          v-if="$hasPermission(MERCHANT_SETTINGS_PERMISSIONS.EDIT)"
          text
          size="large"
          :label="noLogoLabel"
          :to="{
            name: ADMIN_MERCHANT_SETTINGS_EDIT_ROUTE_NAME, params: { id: merchant?.id },
          }"
        />
        <span
          v-else
          class="text-lg text-muted-color"
        >
          {{ noLogoLabel }}
        </span>
      </div>
    </div>
  </div>
</template>
